import React, { useState } from "react";
import Spinner from "react-bootstrap/Spinner";
const PendingAuditionCard = () => {
  const [showSpin, setShowSpin] = useState(true);
  setTimeout(() => {
    setShowSpin(false);
  }, 5000);
  return (
    <div className="row my-4">
      {" "}
      <center>
        {showSpin ? (
          <button className="btn btn-register  fw-bold  mb-3">
            <i className="fas fa-spinner fa-pulse"></i>&nbsp;Upload
          </button>
        ) : (
          <>
            <h5 className="text-danger fw-bold text-center mb-3 ">
              Result Not Published
            </h5>
          </>
        )}
      </center>
    </div>
  );
};

export default PendingAuditionCard;
